class NostoProductsRecommendations extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.swiper')
  }

  connectedCallback() {
    this.initSlider()
    console.log('running ns recommendations')
  }

  initSlider() {
    if (!this.slider) this.slider = this.querySelector('.swiper')
    const swiper = new window.Swiper(this.slider, {
      slidesPerView: 2,
      centeredSlides: false,
      spaceBetween: 16,
      loop: false,
      autoHeight: false,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        744: {
          slidesPerView: 2,
          slidesPerGroup: 2,
        },
        1280: {
          spaceBetween: 24,
          slidesPerView: 4,
          slidesPerGroup: 1,
        }
      },
    });
    
  }
}

customElements.define('ns-products-recommendations', NostoProductsRecommendations);